export const ITEMS_PER_PAGE = 25;
export const DEV_GUIDE_URL = 'https://bambuser.com/docs/on-demand/bam-playlist-integration';
